const initialState = {
  data: null,
}

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_DATA':
      return {
        ...state,
        data: action.payload,
      }
    default:
      return state
  }
}

export default userReducer
